export class gridFilter {

}
export class studyFilter {
  studyNumber: string[] = [];
  tag: string[] = [];
  status: string[] = [];
}
export class filterPrescreened {
  participantName: string[] = [];
  studyNumber: string[] = [];
  age: number[] = [];
  gender: string[] = [];
  dateCreated: string[] = [];
}
export class applicantsFilter {
  participantName: string[] = [];
  phone: string[] = [];
  whentocall: string[] = [];
  age: number[] = [];
  gender: string[] = [];
  studyNumber: string[] = [];
  status: string[] = [];
  dob: string[] = [];
  filterHierarchy: string[] = [];
  searchTerm?: string = '';
  page?: number = 0;
  rows?: number = 50;
  sortField?: string = '';
  sortOrder?: number = 1;
  columnSortingEnabled?: { [field: string]: boolean } = {};
  columnFilteringEnabled?: { [field: string]: boolean } = {};
}
export class questionFilter {
  question: string[] = [];
  tag: string[] = [];
  study: string[] = [];
}
